/* 支払先区分 */
export default {
    MEMBER_STORE: "10", // 加盟店へお支払い (パートナー企業(現地))
    BENEFIT_ONE: "20", // ベネフィット・ワンへお支払い (ベネフィット・ワン)
    PAY_LOCALLY: "30", // 現地でお支払い (その他)
    NO_PAYMENT: "40" // 支払い方法選択なし (支払なし)
}